import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const NoSuppliersMessage = () => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                minHeight: '28px',
            }}
        >
            <CancelOutlinedIcon
                sx={{
                    fontSize: '16px',
                    color: 'error.light',
                }}
            />
            <Typography
                typography="openSans.caption"
                sx={{ color: 'error.light' }}
            >
                {t('No longer carried by suppliers')}
            </Typography>
        </Box>
    );
};
